exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "/*\n  Stylesheet for the page with a list of business model aspects.\n  @author Adrian Rebmann, Yannik Sprengart\n*/\n.margin-twenty[data-v-da0b34d6] {\n  margin-top: 10px;\n  margin-bottom: 10px;\n}\n.no-link[data-v-da0b34d6] {\n  text-decoration: none !important;\n}\n", "", {"version":3,"sources":["/home/gitlab-runner/builds/b21bf5d0/0/mkz/werner-frontend/src/components/search/businessmodelsearch/query/businessmodelsearch.css"],"names":[],"mappings":"AAAA;;;EAGE;AAEF;EACE,iBAAiB;EACjB,oBAAoB;CACrB;AAED;EACE,iCAAiC;CAClC","file":"businessmodelsearch.css","sourcesContent":["/*\n  Stylesheet for the page with a list of business model aspects.\n  @author Adrian Rebmann, Yannik Sprengart\n*/\n\n.margin-twenty {\n  margin-top: 10px;\n  margin-bottom: 10px;\n}\n\n.no-link {\n  text-decoration: none !important;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-da0b34d6","scoped":true,"hasInlineConfig":false}!./src/components/search/businessmodelsearch/query/businessmodelsearch.css
// module id = 6yi7
// module chunks = 1